import { PrivacyPage } from './privacy-page'
import { cmp } from '@otto-ec/eprivacy-cmp'
import { eventQBus } from '@otto-ec/global-resources/event-q-bus'
import { loggingService } from '../utils/logger'
import { AppsAdapter } from '../adapter/apps.adapter'

declare global {
  interface Window {
    o_privacyPage: PrivacyPage
  }
}
export const bootstrap = () => {
  /*                           */
  /*                                                                        */
  window.o_privacyPage = new PrivacyPage(
    document,
    cmp,
    eventQBus,
    new AppsAdapter(),
    loggingService
  )
}

bootstrap()
